import React, { FC } from 'react';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import styles from './CareInfoDialog.module.css';

export const CareInfoDialog: FC<{
    isOpen: boolean;
    handleToggle: any;
    dialogContent: any;
}> = ({ isOpen, handleToggle, dialogContent }) => {
    return (
        <Dialog
            className={styles.careInfoDialog}
            open={isOpen}
            onClose={handleToggle}
        >
            <DialogContent className={styles.careInfoDialogDivider} dividers>
                <IconButton
                    className={styles.careInfoDialogCloseIcon}
                    aria-label="close"
                    onClick={handleToggle}
                >
                    <CloseIcon />
                </IconButton>
                <Typography gutterBottom>{dialogContent}</Typography>
            </DialogContent>
        </Dialog>
    );
};

export default CareInfoDialog;
